<div class="card container">
  <p-confirmDialog />
  <div class="row justify-content-start" style="padding-top: 1rem">
    <div class="col-auto align-self-end">
      <h3 class="card-title" style="margin-bottom: 0">{{ titulo }}</h3>
    </div>
    <div class="col-auto align-self-start">
      <p-button
        label="Nuevo"
        severity="primary"
        icon="pi pi-plus"
        size="small"
        (onClick)="openDialog(true, null)"
      />
    </div>
  </div>
  <div style="padding-top: 50px">
    <p-table
      #dt1
      [value]="ltsNotifications"
      [tableStyle]="{
        'min-width': '50rem',
        'margin-bottom': '50px',
      }"
      styleClass="p-datatable-striped p-datatable-sm"
      [paginator]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
      [globalFilterFields]="['dri_name', 'dri_last_name', 'dri_phone']"
    >
      <ng-template pTemplate="caption"> </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th id="tbtitle">Titulo</th>
          <th id="tbmessage">Mensaje</th>
          <th id="tbcityDestinity">Ciudad de envío</th>
          <th id="tbchannel">Canal</th>
          <th id="tbdatecreation">Fecha de creacion</th>
          <th id="tbdateLastSend">Fecha de ultimo envio</th>
          <th id="tbtype">Tipo</th>
          <th id="tbaction">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-notification>
        <tr>
          <td>{{ notification.not_title }}</td>
          <td>{{ notification.not_message }}</td>
          <td>
            {{
              notification.not_channel == 3
                ? "Todos"
                : (notification.pd_name ?? "Sin Informacion")
            }}
          </td>
          <td>
            {{ getChannelLabel(notification.not_channel) }}
          </td>
          <td>
            <span class="no-break">{{
              notification.not_date | date: "dd-MM-yyyy"
            }}</span>
          </td>
          <td>
            <span class="no-break">{{
              notification.not_last_send | date: "dd-MM-yyyy HH:mm:ss"
            }}</span>
          </td>
          <td>
            {{
              notification.typ_not_name
                ? notification.typ_not_name
                : "Sin información"
            }}
          </td>
          <td>
            <div class="d-flex">
              <p-button
                icon="pi pi-file-edit"
                [rounded]="true"
                severity="info"
                pTooltip="Editar"
                (onClick)="openDialog(false, notification)"
              />
              <p-divider layout="vertical" />
              <p-button
                icon="pi pi-info-circle"
                [rounded]="true"
                severity="info"
                pTooltip="Enviar Notificacion"
                (onClick)="SendNotification($event, notification)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-dialog
  header="{{ tituloDialog }}"
  [resizable]="false"
  [modal]="true"
  [maximizable]="false"
  appendTo="body"
  [(visible)]="dialogNotification"
  [breakpoints]="{ '1199px': '75vw', '575px': '100vw' }"
  [style]="{ width: '45rem', maxHeight: '100vh' }"
  [contentStyle]="{ 'max-height': '300vh', overflow: 'auto' }"
>
  <div class="d-flex justify-content-center">
    <div class="container offset-md-1">
      <form [formGroup]="formNotification" (submit)="saveNotification()">
        <div class="row gap-2">
          <div class="row rowPad align-items-left">
            <div class="col-12 col-sm-3">
              <label for="float-input">Titulo*:</label>
            </div>
            <div class="col-12 col-sm-8">
              <input
                type="text"
                pInputText
                class="largeInput"
                id="name"
                formControlName="not_title"
                placeholder="Titulo"
                style="width: 100%"
              />
              @if (
                formNotification.get("not_title")?.invalid &&
                formNotification.get("not_title")?.dirty
              ) {
                <span class="text-danger labelError">
                  El campo es requerido
                </span>
              }
            </div>
          </div>
          <div class="row rowPad align-items-left">
            <div class="col-12 col-sm-3">
              <label for="float-input">Cuerpo*:</label>
            </div>
            <div class="col-12 col-sm-8">
              <textarea
                pInputTextarea
                class="largeInput"
                id="message"
                formControlName="not_message"
                placeholder="Cuerpo de la Notificación"
                rows="5"
                autoResize="true"
                style="width: 100%"
              ></textarea>
              @if (
                formNotification.get("not_message")?.invalid &&
                formNotification.get("not_message")?.dirty
              ) {
                <span class="text-danger labelError">
                  El campo es requerido
                </span>
              }
            </div>
          </div>
          @if (isCreate) {
            <div class="row rowPad align-items-center">
              <div class="col-12 col-sm-3">
                <label for="float-input">Estado*:</label>
              </div>
              <div class="col-12 col-sm-8">
                <p-dropdown
                  [options]="ltsStates"
                  optionLabel="pd_name"
                  optionValue="pd_code"
                  placeholder="Selecciona un estado"
                  class="m-3"
                  formControlName="not_political_division_id"
                  appendTo="body"
                />
                @if (
                  formNotification.get("not_political_division_id")?.invalid &&
                  formNotification.get("not_political_division_id")?.dirty
                ) {
                  <span class="text-danger labelError">
                    El campo es requerido
                  </span>
                }
              </div>
            </div>
          }
          @if (isCreate) {
            <div class="row rowPad align-items-center">
              <div class="col-12 col-sm-3">
                <label for="float-input">Canal de difusion:*:</label>
              </div>
              <div class="col-12 col-sm-8">
                <p-dropdown
                  [options]="ltsChannels"
                  optionValue="id"
                  optionLabel="name"
                  placeholder="Selecciona un canal"
                  class="m-3"
                  formControlName="not_channel"
                  appendTo="body"
                />
                @if (
                  formNotification.get("not_channel")?.invalid &&
                  formNotification.get("not_channel")?.dirty
                ) {
                  <span class="text-danger labelError">
                    El campo es requerido
                  </span>
                }
              </div>
            </div>
          }
          <div class="d-flex justify-content-end p-2">
            <p-button
              class="p-1"
              label="Cancel"
              severity="primary"
              (onClick)="cancel()"
            />
            <p-button
              class="p-1"
              label="Save"
              type="submit"
              [disabled]="formNotification.invalid"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
